/*
 * Copyright © Vaimo Group. All rights reserved.
 * See LICENSE_VAIMO.txt for license details.
 */

import $ from 'jquery';
import _ from 'underscore';

/**
 * Simple class to add increase and decrease
 * button actions to quantity input element
 */
class detailTabs {
    options = {
        increaseSel: '.qty-increase',
        decreaseSel: '.qty-decrease',
        disabledClass: 'disabled',
        inputSel: '#qty',
        // If value is LOWER than default quantity, it defaults to this value
        defaultQty: 1
    };

    constructor (options, element) {
        this.$element = $(element);
        this.options = _.extend(this.options, options);

        this.$increase = this.$element.find(this.options.increaseSel);
        this.$decrease = this.$element.find(this.options.decreaseSel);
        this.$input = this.$element.find(this.options.inputSel);

        this.storeValue();
        this.afterModifyValue();
        this.bindEvents();
    }

    bindEvents () {
        this.$increase.click(this.increase.bind(this));
        this.$decrease.click(this.decrease.bind(this));

        this.$input.change(this.storeValue.bind(this));
    }

    storeValue () {
        if (!this.$input.val().length || parseInt(this.$input.val(), 10) < this.options.defaultQty) {
            this.$input.val(this.options.defaultQty);
        }

        this.value = parseInt(this.$input.val(), 10);
    }

    setInputValue () {
        this.$input.val(this.value);
        this.$input.trigger('change');
        this.afterModifyValue();
    }

    increase () {
        this.value++;
        this.setInputValue();
    }

    decrease () {
        if (this.value <= 1) {
            return;
        }

        this.value--;
        this.setInputValue();
    }

    afterModifyValue () {
        if (this.value <= 1) {
            this.$decrease.addClass(this.options.disabledClass);
        } else {
            this.$decrease.removeClass(this.options.disabledClass);
        }
    }
}

export default (options, element) => new detailTabs(options, element);
